document.addEventListener('DOMContentLoaded', () => {

  const cards = [...document.querySelectorAll('.ld-video-card')];

  if (!cards.length) return;

  const modal = document.querySelector('.ld-video-modal');
  const overlay = modal.querySelector('.ld-video-overlay');
  const dialog = modal.querySelector('.ld-video-dialog');
  const closeBtn = modal.querySelector('.ld-video-close');

  const player = document.getElementById('ld-modal-player');
  const title = document.getElementById('ld-video-title');
  const fan = document.getElementById('ld-video-fan');
  const country = document.getElementById('ld-video-country');

  const spotify = document.getElementById('ld-modal-spotify');
  const product = document.getElementById('ld-modal-product');

  const prevBtn = modal.querySelector('.ld-video-prev');
  const nextBtn = modal.querySelector('.ld-video-next');

  const loadMore = document.querySelector('.ld-loadmore');

  let currentIndex = 0;

  /*=========================================
  LOAD MORE
  =========================================*/

  if (loadMore) {

    loadMore.addEventListener('click', () => {

      const hidden = document.querySelectorAll('.ld-hidden-video');

      [...hidden]
        .slice(0, 8)
        .forEach(card => card.classList.remove('ld-hidden-video'));

      if (!document.querySelector('.ld-hidden-video')) {

        loadMore.parentElement.style.display = 'none';

      }

    });

  }

  /*=========================================
  OPEN VIDEO
  =========================================*/

  function openVideo(index) {

    currentIndex = index;

    const card = cards[index];

    if (!card) return;

    player.innerHTML = '';

    const template = document.getElementById(card.dataset.template);

    if (template) {

      const video = template.content.firstElementChild.cloneNode(true);

      video.removeAttribute('controlslist');

      player.appendChild(video);

      const media = player.querySelector('video');

      if (media) {

        media.currentTime = 0;

        media.play().catch(() => {});

      }

    }

    title.textContent = card.dataset.title || '';

    fan.textContent = card.dataset.fan || '';

    if (card.dataset.country) {

      country.textContent = card.dataset.country;

      country.style.display = '';

    } else {

      country.style.display = 'none';

    }

    product.href = card.dataset.product || '#';

    if (card.dataset.spotify) {

      spotify.href = card.dataset.spotify;

      spotify.style.display = '';

    } else {

      spotify.style.display = 'none';

    }

    modal.classList.add('active');

    modal.setAttribute('aria-hidden', 'false');

    document.body.classList.add('overflow-hidden');

  }

  /*=========================================
  CLOSE VIDEO
  =========================================*/

  function closeVideo() {

    const media = player.querySelector('video');

    if (media) {

      media.pause();

      media.currentTime = 0;

    }

    player.innerHTML = '';

    modal.classList.remove('active');

    modal.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('overflow-hidden');

  }

  /*=========================================
  NEXT / PREVIOUS
  =========================================*/

  function nextVideo() {

    openVideo((currentIndex + 1) % cards.length);

  }

  function previousVideo() {

    openVideo((currentIndex - 1 + cards.length) % cards.length);

  }

  /*=========================================
  CARD EVENTS
  =========================================*/

  cards.forEach((card, index) => {

    const trigger = card.querySelector('[data-open-video]');

    if (!trigger) return;

    trigger.addEventListener('click', e => {

      e.preventDefault();

      openVideo(index);

    });

  });

  /*=========================================
  MODAL EVENTS
  =========================================*/

  closeBtn.addEventListener('click', closeVideo);

  overlay.addEventListener('click', closeVideo);

  prevBtn.addEventListener('click', previousVideo);

  nextBtn.addEventListener('click', nextVideo);

  /*=========================================
  KEYBOARD
  =========================================*/

  document.addEventListener('keydown', e => {

    if (!modal.classList.contains('active')) return;

    switch (e.key) {

      case 'Escape':

        closeVideo();

        break;

      case 'ArrowLeft':

        previousVideo();

        break;

      case 'ArrowRight':

        nextVideo();

        break;

    }

  });

  /*=========================================
  FOCUS TRAP
  =========================================*/

  dialog.addEventListener('keydown', e => {

    if (e.key !== 'Tab') return;

    const focusable = dialog.querySelectorAll(
      'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {

      e.preventDefault();

      last.focus();

    } else if (!e.shiftKey && document.activeElement === last) {

      e.preventDefault();

      first.focus();

    }

  });

});